/**
 * The canonical "successor-picker submission → single assignee" rule, shared
 * by every submit path: the first non-empty collection wins, in the order
 * persons → orgFunctions → systems → externalContacts. Returns `undefined`
 * when the submission has no assignee — callers should skip their patch and
 * just close the picker.
 */ export function pickFirstAssignee(data) {
    if (data.persons?.length) {
        return {
            ref: {
                type: "entity",
                id: data.persons[0]
            },
            model: "User"
        };
    }
    const firstOrgFunction = data.orgFunctions?.[0];
    if (firstOrgFunction) {
        return {
            ref: firstOrgFunction,
            model: "OrgFunction"
        };
    }
    const firstSystem = data.systems?.[0];
    if (firstSystem) {
        return {
            ref: firstSystem,
            model: "System"
        };
    }
    if (data.externalContacts?.length) {
        return {
            ref: {
                type: "entity",
                id: data.externalContacts[0]
            },
            model: "ExternalContact"
        };
    }
    return undefined;
}
/**
 * Convert a successor-picker submission into a `(assignedTo, assignedToModel)`
 * patch. Suggestion refs pass through as-is — the slot is assigned the pending
 * suggestion and resolves to a real entity when the suggestion is approved.
 */ export function buildAssigneePatch(data) {
    const picked = pickFirstAssignee(data);
    if (!picked) return undefined;
    return {
        assignedTo: picked.ref,
        assignedToModel: picked.model
    };
}

//# sourceMappingURL=assigneeSubmit.js.map